const API_BASE = "https://blog.gandyengineering.com/api";

const SHORT_DATE_FORMAT = new Intl.DateTimeFormat("en-GB", {
  day: "2-digit",
  month: "short",
  year: "numeric",
});

export async function fetchJson(path) {
  const response = await fetch(`${API_BASE}${path}`);

  if (!response.ok) {
    throw new Error(
      `G&Y News API request failed (${response.status} ${response.statusText})`
    );
  }

  return response.json();
}

export function getMediaUrl(media) {
  const url = media?.url;

  if (!url) {
    return null;
  }

  if (url.startsWith("http://") || url.startsWith("https://")) {
    return url;
  }

  return `https://blog.gandyengineering.com${url}`;
}

// Compact "07 May 2026" label for listing cards. Returns "" for a missing or
// unparseable timestamp so callers can skip rendering the element entirely
// rather than showing an empty or "Invalid Date" string.
export function formatShortDate(value) {
  if (!value) {
    return "";
  }

  const date = new Date(value);

  if (Number.isNaN(date.getTime())) {
    return "";
  }

  return SHORT_DATE_FORMAT.format(date);
}
